const signChat = {
  // 注册环信账号
  hxRegister: `/userApi/v1/PrivateChat/hxRegister`,
  // 获取用户所有关系数据
  getAllRelationshipsData: `/userApi/v1/PrivateChat/getAllRelationshipsData`,
  // 获取单个用户关系
  getSingleRelationships: `/userApi/v1/PrivateChat/getSingleRelationships`,
  // 批量获取用户信息
  batchGetUserData: `/userApi/v1/PrivateChat/batchGetUserData`,
  // 检测消息是否通过
  checkMessageLegal: `/userApi/v1/PrivateChat/checkMessageLegal`,
  // 设置/取消私聊黑名单
  operateBlackList: `/userApi/v1/PrivateChat/operateBlackList`,
  // 记录违规消息
  recordViolationMessage: `/userApi/v1/PrivateChat/recordViolationMessage`,
  // 服务端代发消息
  proxySendMessage: `/userApi/v1/PrivateChat/proxySendMessage`
};

export default signChat;
